export default __webpack_public_path__ + "static/media/Time_Black.1794e066.webp";